// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles-module__modal___157A_","body":"styles-module__body___2aG55"};